<!-- Page Content-->
<!-- <app-mobile-menu></app-mobile-menu> -->
<div class="d-flex flex-column">
<nav-bar></nav-bar>
<!-- <pag-title></pag-title> -->
<!-- <div class="padding-bottom-1x mb-1 d-print-none"></div> -->
<div class="router-component fw-section flex-fill">
  <!-- <div class="loading"></div> -->
  <ng-content></ng-content>

  <router-outlet (activate)="activate()"></router-outlet>
</div>
<!-- <div class="padding-bottom-4x mb-4 d-print-none"></div>
<div class="padding-bottom-4x mb-4 d-print-none"></div> -->
<!-- Back To Top Button-->
<a class="scroll-to-top-btn d-print-none" href="javascript:void(0);">
  <i class="material-icons trending_flat"></i>
</a>
<!-- Backdrop-->
<!-- <div class="site-backdrop"></div> -->
<div fw-footer></div>
</div>